import type { TError } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';
import type { TQuizAttempt } from './start-attempt';

/**
 * Query key for fetching user's attempts for a quiz
 */
export const useGetUserAttemptsQueryKey = (quizId: string) => [ENTITY, 'quiz', quizId, 'attempts'];

/**
 * Hook to fetch user's attempts for a specific quiz
 *
 * @param quizId - Quiz ID (UUID)
 */
export const useGetUserAttempts = (quizId: string) => {
  return useQuery<TQuizAttempt[], TError>({
    queryKey: useGetUserAttemptsQueryKey(quizId),
    queryFn: async () => {
      const res = await axios.get<TQuizAttempt[]>(`/community-hub/quizzes/${quizId}/attempts`);
      return res.data;
    },
    enabled: !!quizId,
  });
};
